import { render, staticRenderFns } from "./TheAllDBsDashboard.vue?vue&type=template&id=5830e306&"
import script from "./TheAllDBsDashboard.vue?vue&type=script&lang=js&"
export * from "./TheAllDBsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports